import { useTranslation } from 'react-i18next'
import InputWrapper from '../Formik/InputWrapper'
import Label from '../Formik/Label'
import Input from '../Formik/Input'
import { Select } from '../Select'
import { countriesOptions } from '../../helpers/countriesOptions'
import { ORGANIZATION_TITLE_MAX_LENGTH } from '../../helpers/organizationLimits'
import AllFieldsRequiredLabel from '../UI/AllFieldsRequiredLabel'
import RequiredLabelWrapper from '../UI/RequiredLabelWrapper'

interface Props {
  formik: any
}

const PaymentBillingDetailsForm = ({ formik }: Props) => {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col'>
      <h2 className='text-[24px] font-bold'>{t('billingInformation')}</h2>
      <p className='mb-7 text-lightGray'>
        {t('billingInformationDescription')}
      </p>
      <AllFieldsRequiredLabel />
      <div className='mt-4 grid sm:grid-cols-2 gap-5 sm:gap-10'>
        <div className='sm:col-span-2'>
          <InputWrapper>
            <RequiredLabelWrapper>
              <Label text={t('companyName')} />
            </RequiredLabelWrapper>
            <Input
              id='companyName'
              as='input'
              type='text'
              maxLength={ORGANIZATION_TITLE_MAX_LENGTH}
              hasError={
                !!(formik.touched.companyName && formik.errors.companyName)
              }
              {...formik.getFieldProps('companyName')}
            />
          </InputWrapper>
        </div>
        <InputWrapper>
          <RequiredLabelWrapper>
            <Label text={t('companyEmail')} />
          </RequiredLabelWrapper>
          <Input
            id='companyEmail'
            as='input'
            type='email'
            hasError={
              !!(formik.touched.companyEmail && formik.errors.companyEmail)
            }
            {...formik.getFieldProps('companyEmail')}
          />
        </InputWrapper>
        <InputWrapper>
          <RequiredLabelWrapper>
            <Label text={t('companyTaxId')} />
          </RequiredLabelWrapper>
          <Input
            id='companyTaxId'
            as='input'
            type='text'
            hasError={
              !!(formik.touched.companyTaxId && formik.errors.companyTaxId)
            }
            {...formik.getFieldProps('companyTaxId')}
          />
        </InputWrapper>

        <InputWrapper>
          <RequiredLabelWrapper>
            <Label text={t('country')} />
          </RequiredLabelWrapper>
          <Select
            isSearchable
            options={countriesOptions}
            onChange={(value: { value: string; label: string }) => {
              formik.setFieldValue('country', value.value)
            }}
            onBlur={() => {
              formik.setFieldTouched('country', true)
            }}
            value={countriesOptions.find(
              (option) => option.value === formik.values.country,
            )}
            isError={!!(formik.touched.country && formik.errors.country)}
            translateLabel={false}
          />
        </InputWrapper>
        <InputWrapper>
          <RequiredLabelWrapper>
            <Label text={t('state')} />
          </RequiredLabelWrapper>
          <Input
            id='state'
            as='input'
            type='text'
            hasError={!!(formik.touched.state && formik.errors.state)}
            {...formik.getFieldProps('state')}
          />
        </InputWrapper>
        <InputWrapper>
          <RequiredLabelWrapper>
            <Label text={t('city')} />
          </RequiredLabelWrapper>
          <Input
            id='city'
            as='input'
            type='text'
            hasError={!!(formik.touched.city && formik.errors.city)}
            {...formik.getFieldProps('city')}
          />
        </InputWrapper>
        <InputWrapper>
          <RequiredLabelWrapper>
            <Label text={t('postalCode')} />
          </RequiredLabelWrapper>
          <Input
            id='postalCode'
            as='input'
            type='text'
            hasError={!!(formik.touched.postalCode && formik.errors.postalCode)}
            {...formik.getFieldProps('postalCode')}
          />
        </InputWrapper>
        <div className='sm:col-span-2'>
          <InputWrapper>
            <RequiredLabelWrapper>
              <Label text={t('address1')} />
            </RequiredLabelWrapper>
            <Input
              id='address1'
              as='input'
              type='text'
              hasError={
                !!(formik.touched.addressLine1 && formik.errors.addressLine1)
              }
              {...formik.getFieldProps('addressLine1')}
            />
          </InputWrapper>
        </div>
        <div className='sm:col-span-2'>
          <InputWrapper>
            <Label text={t('address2')} />
            <Input
              id='address2'
              as='input'
              type='text'
              hasError={
                !!(formik.touched.addressLine2 && formik.errors.addressLine2)
              }
              {...formik.getFieldProps('addressLine2')}
            />
          </InputWrapper>
        </div>
      </div>
    </div>
  )
}

export default PaymentBillingDetailsForm
